var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { runInAction } from "mobx";
export var keepTruthy = function (arr) { return arr.filter(function (i) { return i; }); };
export function replaceArrayContent(arr, newItems) {
    arr.splice(0);
    arr.push.apply(arr, newItems);
}
export function replaceContents(arr, newContent) { arr.splice.apply(arr, __spreadArray([0, arr.length], (newContent !== null && newContent !== void 0 ? newContent : []), false)); }
;
export function groupArray(arr, n) {
    var group = [];
    for (var i = 0, j = 0; i < arr.length; i++) {
        if (i >= n && i % n === 0)
            j++;
        group[j] = group[j] || [];
        group[j].push(arr[i]);
    }
    return group;
}
export var removeFromArray = function (arr) {
    var itemsToRemove = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        itemsToRemove[_i - 1] = arguments[_i];
    }
    if (!arr)
        return arr;
    for (var _a = 0, itemsToRemove_1 = itemsToRemove; _a < itemsToRemove_1.length; _a++) {
        var item = itemsToRemove_1[_a];
        var i = arr.indexOf(item);
        while (i >= 0) {
            arr.splice(i, 1);
            i = arr.indexOf(item);
        }
    }
    return arr;
};
export var mapToIds = function (arr) { return arr.map(function (a) { return a.id + ''; }); };
export var joinTruthy = function (separator) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return args.filter(function (x) { return x; }).join(separator);
};
export var joinTruthyFactory = function (separator) {
    if (separator === void 0) { separator = ','; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return joinTruthy.apply(void 0, __spreadArray([separator], args, false));
    };
};
export var joinTruthyWithSpace = joinTruthyFactory(' ');
export var sortRandomly = function (arr) { return Array.from(arr).sort(function (a, b) { return .5 - Math.random(); }); };
export var addToArrayIfNew = function (arr) {
    var itemsToAdd = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        itemsToAdd[_i - 1] = arguments[_i];
    }
    if (!arr)
        return arr;
    var _loop_1 = function (item) {
        if (arr.includes(item))
            return "break";
        runInAction(function () {
            arr.push(item);
        });
    };
    for (var _a = 0, itemsToAdd_1 = itemsToAdd; _a < itemsToAdd_1.length; _a++) {
        var item = itemsToAdd_1[_a];
        var state_1 = _loop_1(item);
        if (state_1 === "break")
            break;
    }
    return arr;
};
export function pushToOrReplaceItemsInArray(originalArray, newItems, matcher) {
    if (matcher === void 0) { matcher = function (i, a) { return a.indexOf(i); }; }
    newItems.forEach(function (e) {
        var existingItemIndex = matcher(e, originalArray);
        if (existingItemIndex >= 0) {
            originalArray.splice(existingItemIndex, 1);
        }
        originalArray.push(e);
    });
}
export function transformArray(arr, transformer, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var _b = options.transformInPlace, transformInPlace = _b === void 0 ? true : _b;
    var result = arr.map(function (x, i, a) { return transformer(x, i, a); });
    if (transformInPlace) {
        arr.splice(0);
        (_a = arr).push.apply(_a, result);
        return arr;
    }
    return result;
}
